function active_filters() {
    let product_grid = document.querySelector('.product_grid > div:last-child');

    if( product_grid ) {
        products_active = product_grid.querySelectorAll('.product_card[data-active="1"]');

        // console.log({products_active});

        document.querySelectorAll('.product_grid > div:first-child > div').forEach( element => {
            element.setAttribute('data-active', 0);
        });
        
        products_active.forEach( element => {
            for (const attr of element.attributes) {
                if( attr.name.startsWith('data-filter-') ) {
                    filter = attr.name;
                    // console.log({filter});
                    document.querySelector('.product_grid > div:first-child > [' + filter + ']').setAttribute('data-active', 1);
                }
            }

        }); 
    }
        
}

function filter_control() {
    const filter_triggers = document.querySelectorAll('.product_grid > div:first-child .filter');

    if( filter_triggers.length > 0 ) {
        filter_triggers.forEach( element => {
            element.addEventListener('click', (event) => {

                if( 
                    ! element.classList.contains('reset') &&
                    ! element.classList.contains('live_filter') 
                ) {

                    let parent = document.querySelector('.product_grid'),
                        filters = parent.querySelectorAll('[data-active]'),
                        product_cards = parent.querySelectorAll('.product_card[data-active="1"]'),
                        filter = '',
                        filter_val = '';


                    element.toggleAttribute('data-active');
                    let filters_active = document.querySelectorAll('.product_grid > div:first-child .filter[data-active]:not(.reset)');
                    
                    // console.log('============');
                    // console.log(product_cards.length);
                    filters_active.forEach( element => {
                        for (const attr of element.attributes) {
                            if( attr.name.startsWith('data-filter-') ) {
                                filter = attr.name;
                                filter_val = attr.value;
                            }
                        }
                        // console.log(filter + ' = ' + filter_val);
                        product_cards.forEach( element => {
                            let element_filter = element.getAttribute(filter);
                            if( 
                                element_filter == null || 
                                element_filter !== null && ! element_filter.includes(filter_val)
                            ) {
                                element.removeAttribute('data-active');
                            }
                        });
                    });
                    
                } else {
                    document.querySelectorAll('.product_card').forEach( element => {
                        element.setAttribute('data-active', "1");
                    });
                    document.querySelectorAll('.filter:not(.reset)').forEach( element => {
                        element.removeAttribute('data-counter-zero');
                        element.removeAttribute('data-active');
                    });
                    document.querySelector('.live_filter input').value = '';
                }

                active_filters();
                filter_counter();
                
                
            });
        });
    }

    let url_params = new URLSearchParams(window.location.search),
        pre_filter = url_params.get('f');

    if( pre_filter !== null ) {
        if( pre_filter == 'Vibro-Lo' ) {
            document.querySelector('.product_grid').querySelector('[data-filter-specification="' + pre_filter + '"]').click();
        } else if( pre_filter !== 'x' ) {
            document.querySelector('.product_grid').querySelector('[data-filter-type="' + pre_filter + '"]').click();
        }
        document.querySelector('.product_types').scrollIntoView();
    }

    active_filters();
    
}

filter_control();

function filter_counter() {    
    let product_grid = document.querySelector('.product_grid > div:last-child');

    document.querySelectorAll('.product_grid > div:first-child .filter:not(.reset)').forEach( element => {
        let filter = '',
            filter_val = '',
            counter = document.createElement('span'),
            count = 0;

        for (const attr of element.attributes) {
            if( attr.name.startsWith('data-filter-') ) {
                filter = attr.name;
                filter_val = attr.value;
            }
        }

        count = product_grid.querySelectorAll('.product_card[data-active][' + filter + '*="' + filter_val + '"]').length;
        counter.append(' (' + count + ')');
        // element.querySelector('span').remove();

        if( element.innerHTML.indexOf('span') < 0 ) {
            element.append(counter);
        } else {
            element.querySelector('span').textContent = ' (' + count + ')';
        }

        element.setAttribute('style', 'order:' + count);
        if( count < 1 ) {
            element.setAttribute('data-counter-zero', 1);
        }
    });

}